import React, { useEffect, useState, useContext } from "react";

import plus from "../../assets/Plus.svg";
import LogicContext from "../../Context/LogicContext";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Table } from "react-bootstrap";
import CurrencyFormat from 'react-currency-format';
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

function AddInvoiceTable(props) {
  const [itemTableList, setItemTableList] =  useState([]);
  const logicContext = useContext(LogicContext);

   useEffect(()=> {
    let timeoutId;
    if(props?.defaultTableData?.length > 0){

    let newList = props?.defaultTableData?.map(item => {
      return {...item, Rate: item?.Rate }
    });
    setItemTableList(newList);
    timeoutId = setTimeout(() => {
      props?.onSelectionList([...newList])
    }, 2500);
    }
    return () => {
      clearTimeout(timeoutId);
    }
   },[])





  return (
    <section className="mx-2  mt-2 max-auto border-2 py-2 px-2 max-w-6xl text-filterTextColor">
    <section className=" ">
      <section className=" mt-1 right-1   md:  ">
        <section className="">
          <section className="profile_section ">
            <section className="mt-3">
      
                   <TableContainer className="mt-3">
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead style={{ backgroundColor: "#F1F1F1" }}>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>SKU</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Rate</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
         
             {/* {itemTableList?.map((item,i)=> { */}
             {props?.productPlanList?.map((item,i)=> {
              return(

                <TableRow key={i}
               
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left">{item?.Item_Id} </TableCell>
                <TableCell align="left">{item?.Item_Name} </TableCell>
                <TableCell align="left">{item.Item_Sku} </TableCell>
                <TableCell align="left"> {item?.Product_Feature_Name} </TableCell>
                
                <TableCell align="left"> {" "}
                  <input
                    type="number"
                    defaultValue={item?.Quantity}
                    style={{ width: "70px" }}
                    onChange={(e)=> props.onQuantityChange(e.target.value, i)}
                 
                  />{" "}
                </TableCell>
                <TableCell align="left"> 
                  <CurrencyFormat value={formatCustomNumber(item?.Rate)}
                         displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                   </TableCell>

                <TableCell align="left"> 
                <CurrencyFormat value={formatCustomNumber(item?.Rate)}
                       displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                 </TableCell>

                   <TableCell className="subheading" align="left">
                    <CurrencyFormat value={formatCustomNumber(item.Rate * item.Quantity)}
                        displayType={'text'} thousandSeparator={true} prefix={'₦'} />
                </TableCell>

                <TableCell className="subheading" align="left">
                  <DeleteIcon onClick={() => props?.removeOldAddon(i)} />
              </TableCell>
              </TableRow>
              )
             })}
              
             
            </TableBody>
          </Table>
        </TableContainer>
            </section>
          </section>
        </section>
      </section>
    </section>
  </section>
  );
}

export default AddInvoiceTable;
